import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import StoreIcon from "@mui/icons-material/Store";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import { Link } from "react-router-dom";
import { SoecoButton } from "../../components/SoecoButton";
import styled from "styled-components";
import { EmployeeContext } from "../../context/EmployeeContext";
import { CompanyContext } from "../../context/CompanyContext";
import { useContext, useEffect, useState } from "react";
import { theme } from "../../theme";
import { Grid2x2Plus, Grid2X2, UserCog, Merge } from "lucide-react";
import { Typography } from "@mui/material";
import { useGetCompany, useIsSubSubCompany } from "../../hooks/companyHooks";
import { useTheme } from "@mui/material/styles";

const color = theme.palette.primary.main;
const hooverColor = theme.palette.secondary.main;
export const AdminMenu = () => {
    const { employee } = useContext(EmployeeContext);
    const { company } = useContext(CompanyContext);
    const { data: companyData } = useGetCompany(employee.companyId);
    const { isSubSubCompany, isLoading: isDepthLoading } = useIsSubSubCompany(employee.companyId);
    const theme = useTheme();

    return (
        <MenuWrapper>
            <MenuButton to={`/companies/${employee.companyId}/manageUsers`}>
                <UserCog
                    style={{
                        color: theme.palette.primary.main,
                        transition: "color 0.2s ease",
                    }}
                    size={82}
                    onMouseEnter={e => (e.currentTarget.style.color = theme.palette.secondary.main)}
                    onMouseLeave={e => (e.currentTarget.style.color = theme.palette.primary.main)}
                />
                <Typography
                    color="#8c8c8c"
                    fontWeight={600}
                    fontSize={20}
                    marginTop={"4px"}
                    sx={{ fontFamily: "Inter, sans-serif" }}
                >
                    {"Manage users"}
                </Typography>
            </MenuButton>
            <MenuButton to={`/companies/${employee.companyId}/manageCompanies`}>
                <Grid2X2
                    style={{
                        color: theme.palette.primary.main,
                        transition: "color 0.2s ease",
                    }}
                    size={82}
                    onMouseEnter={e => (e.currentTarget.style.color = theme.palette.secondary.main)}
                    onMouseLeave={e => (e.currentTarget.style.color = theme.palette.primary.main)}
                />
                <Typography
                    color="#8c8c8c"
                    fontWeight={600}
                    fontSize={20}
                    marginTop={"4px"}
                    sx={{ fontFamily: "Inter, sans-serif" }}
                >
                    {"Manage companies"}
                </Typography>
            </MenuButton>
            {companyData?.canCreateSubcompany && !isDepthLoading && !isSubSubCompany ? (
                <MenuButton to={`/companies/${employee.companyId}/manageSubCompanies`}>
                    <Grid2x2Plus
                        style={{
                            color: theme.palette.primary.main,
                            transition: "color 0.2s ease",
                        }}
                        size={82}
                        onMouseEnter={e =>
                            (e.currentTarget.style.color = theme.palette.secondary.main)
                        }
                        onMouseLeave={e =>
                            (e.currentTarget.style.color = theme.palette.primary.main)
                        }
                    />
                    <Typography
                        color="#8c8c8c"
                        fontWeight={600}
                        fontSize={20}
                        marginTop={"4px"}
                        sx={{ fontFamily: "Inter, sans-serif" }}
                    >
                        {"Manage Sub-Companies"}
                    </Typography>
                </MenuButton>
            ) : null}
            {/* <MenuButton to={`merge`}>
                <Merge
                    style={{
                        color: theme.palette.primary.main,
                        transition: "color 0.2s ease",
                    }}
                    size={82}
                    onMouseEnter={e => (e.currentTarget.style.color = theme.palette.secondary.main)}
                    onMouseLeave={e => (e.currentTarget.style.color = theme.palette.primary.main)}
                />
                <Typography
                    color="#8c8c8c"
                    fontWeight={600}
                    fontSize={20}
                    marginTop={"4px"}
                    sx={{ fontFamily: "Inter, sans-serif" }}
                >
                    {"Merge inventories"}
                </Typography>
            </MenuButton> */}
        </MenuWrapper>
    );
};

const MenuWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    padding-top: 30px;
    margin-top: 50px;
    gap: 30px;
`;

const MenuButton = styled(Link)`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    svg {
        color: ${color};
        font-size: 150px;
        &:hover {
            color: ${hooverColor};
        }
    }
    text-decoration: none;
    color: inherit;
`;

const ButtonWrapper = styled.div`
    margin-top: 20px;
`;
